
const texts = {
    title: 'Seleccionar por',
    inputFilter: {
        nombreFir:'Nombre del Firmante',
        apellidoFir:'Apellido del Firmante',
        cuitFir:'CUIL del Firmante',
        emailFir: 'Email del Firmante',
        estadoDoc:'Estado del Documento',
        estadoDocOpcion:{
            publicado: 'Documento publicado',
            pendiente: 'Documento pendiente',
            cerrado: 'Documento terminado',
            rechazado: 'Documento vencido o rechazado',
        },
        entreFechasDesde:'Desde',
        fechaInDes:'Fecha de inicio desde',
        entreFechas:'Hasta',
        fechaInHas:'Fecha de inicio hasta',
        tipFirma:'Tipo de Firma',
        tituloDoc:'Título Documento',
        nombrePublicador: 'Nombre Publicador',
    },
    errorMessages: {
      rechazo:'EF003: No se pudo completar la acción. Probá de nuevo en unos minutos. Si sigue el problema, escribí a soporte.',
      networkError: 'EF001: Hubo un error de conexión con el servidor. Probá otra vez en unos minutos.',
      errorFiltrar: 'EF0021 : Se produjo un error con los filtros seleccionados. Vuelva a intentar la operación. De persistir el error contacte a soporte.',
      peticionTardo:'EF002: El servidor no respondió. Probá de nuevo en unos minutos. Si el problema sigue, escribí a soporte.',
    },
    buttons: {
      clean: 'Limpiar filtros',
    },
  };
  
  export default texts;
  